var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown icon-dropdown", class: _vm.classBindings },
    [
      _c(
        "button",
        {
          staticClass:
            "btn btn-outline-secondary btn-icon rounded-circle menu-toggle",
          on: { click: _vm.toggleMenu }
        },
        [
          _vm.horizontal
            ? _c("i", { staticClass: "material-icons" }, [
                _vm._v("\n      more_horiz\n    ")
              ])
            : _c("i", { staticClass: "material-icons" }, [
                _vm._v("\n      more_vert\n    ")
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dropdown-menu dropdown-menu-right" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb50ada", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fb50ada","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconDropdown.vue
// module id = VFCK
// module chunks = 1